export default __webpack_public_path__ + "static/media/military.1c3f14ee.jpg";